import axios from 'axios'

const AuthenticationService = {
  login(accessToken?: string) {
    const token = accessToken ?? sessionStorage.getItem('vfuToken')
    const apiUrl = process.env.REACT_APP_API_URL
    const options = {
      baseURL: apiUrl,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        'Access-Control-Allow-Origin': '*',
        withCredentials: true,
        Authorization: token ? `Bearer ${token}` : undefined,
      },
    }
    const axiosInstance = axios.create(options)
    return axiosInstance.post('/validate_token/')
  },
}

export default AuthenticationService
